// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoLockOutlinedSvg from "@fishx/icons-svg/es/asn/PtoLockOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoLockOutlined = function PtoLockOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoLockOutlinedSvg
  }));
};

PtoLockOutlined.displayName = 'PtoLockOutlined';
export default React.forwardRef(PtoLockOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoLockOutlined.js
// module id = 3916
// module chunks = 0